import type { AssignableUser, LeadBoard, LeadDetail } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface BoardFilters { meus?: boolean; origem?: string; etiqueta?: string; q?: string }

export const boardQuery = (f: BoardFilters) => queryOptions({
  queryKey: ['crm', 'board', f],
  queryFn: () => {
    const qs = new URLSearchParams({ ...(f.meus ? { meus: '1' } : {}), ...(f.origem ? { origem: f.origem } : {}), ...(f.etiqueta ? { etiqueta: f.etiqueta } : {}), ...(f.q ? { q: f.q } : {}) });
    return api<LeadBoard>(`/crm/board?${qs}`);
  },
  staleTime: 20_000,
});
export const leadQuery = (id: string) => queryOptions({ queryKey: ['crm', 'lead', id], queryFn: () => api<LeadDetail>(`/crm/leads/${id}`) });
export const leadByContactQuery = (contactId: string) => queryOptions({
  queryKey: ['crm', 'by-contact', contactId], queryFn: () => api<LeadDetail | null>(`/crm/leads/by-contact/${contactId}`),
});
export const assignableQuery = queryOptions({
  queryKey: ['crm', 'assignable'], queryFn: () => api<AssignableUser[]>('/crm/assignable-users'), staleTime: 300_000,
});
